import { render, staticRenderFns } from "./ProgramDaysBox.vue?vue&type=template&id=820b2cd6"
import script from "./ProgramDaysBox.vue?vue&type=script&lang=js"
export * from "./ProgramDaysBox.vue?vue&type=script&lang=js"
import style0 from "./ProgramDaysBox.vue?vue&type=style&index=0&id=820b2cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports